export const motorProps = [
    {
        id:1,
        img:"https://www.autoboxmotors.com/images/vehicles/6042/975556ea62bb137fc82b10fe48b6074a.jpeg",
        cost:"45000"
    },
    {
        id:2,
        img:"https://pictures-kenya.jijistatic.com/12561875_img-20200917-wa0012_1280x762.jpg",
        cost:"3000"
    },
    {
        id:3,
        img:"https://www.globalconstructionreview.com/wp-content/uploads/2021/08/EV.jpg",
        cost:"1000"
    },
    {
        id:4,
        img:"https://image.made-in-china.com/44f3j00ZUGtANyhZHkY/Isuzu-Diesel-4X2-Pickup-with-Best-Price-for-Sale.jpg",
        cost:"28000"
    },
    {
        id:5,
        img:"https://m.atcdn.co.uk/a/media/w540/08fa6b0dc77b4c4a9a2e5d10e615c587.jpg",
        cost:"16000"
    }
];

export const FurnitureProps = [
    {
        id:1,
        img:"https://images.pexels.com/photos/698170/pexels-photo-698170.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
        cost:"2000"
    },
    {
        id:2,
        img:"https://elegance.co.ke/pub/media/wysiwyg/off-img-1.jpg",
        cost:"500"
    },
    {
        id:3,
        img:"https://images.pexels.com/photos/276566/pexels-photo-276566.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
        cost:"380"
    },
    {
        id:4,
        img:"https://images.pexels.com/photos/1571463/pexels-photo-1571463.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
        cost:"800"
    },
    
];
export const electroProps = [
    {
        id:1,
        img:"https://images.pexels.com/photos/788946/pexels-photo-788946.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        cost:"600"
    },
    {
        id:2,
        img:"https://images.pexels.com/photos/1229861/pexels-photo-1229861.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
        cost:"1500"
    },
    {
        id:3,
        img:"https://images.pexels.com/photos/205926/pexels-photo-205926.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        cost:"600"
    },
    {
        id:4,
        img:"https://images.pexels.com/photos/51383/photo-camera-subject-photographer-51383.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
        cost:"28000"
    },
    {
        id:5,
        img:"https://images.pexels.com/photos/682933/pexels-photo-682933.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
        cost:"16000"
    }
];

export const landProps = [
    {
        id:1,
        img:"https://www.pointproperties.org/wp-content/uploads/2019/03/10-Acre-tea-Farm-Tigoni-2.jpeg",
        cost:"$ 45000"
    },
    {
        id:2,
        img:"https://natureconservancy-h.assetsadobe.com/is/image/content/dam/tnc/nature/en/photos/tnc_71904862_4000x2200.jpg?crop=0,0,4000,2200&wid=4000&hei=2200&scl=1.0",
        cost:"$ 3000"
    },
    {
        id:3,
        img:"https://propscout.co.ke/storage/properties/files/lands-plots/thumbnails/-land-for-sale-in-kariamu-ol-kalau-xehfg.jpg",
        cost:"$ 1000"
    },
    {
        id:4,
        img:"https://propscout.co.ke/storage/properties/files/lands-plots/webp/kenyatta-road-land-for-sale-i8i5y.webp",
        cost:"$ 28000"
    },
    {
        id:5,
        img:"https://pictures-kenya.jijistatic.com/3755009_img-20191017-124849_1500x1500.jpg",
        cost:"$ 16000"
    }
];